import { useMemo, useState } from 'react'
import { useApiListNodeGroup, useApiListNodeOrg } from '../../api-new/state/content'
import { ModalDialog } from '../component/modal-dialog'
import { TextFilter } from './text-filter'
import { ButtonPrimary } from '../component/button'

export const PermissionGroupNodeModal = ({ target, groupID, allowAdd, allowDelete, onClose, onClosed }) => {
  const [filter, updateFilter] = useState('')

  const apiListNodeOrg = useApiListNodeOrg()
  const apiListNodeGroup = useApiListNodeGroup()

  const filteredItems = useMemo(
    () => {
      let lowerFilter = filter.toLowerCase()
      return apiListNodeOrg.items.filter(i => i.name.toLowerCase().includes(lowerFilter) || i.path.toLowerCase().includes(lowerFilter))
    },
    [apiListNodeOrg.items, filter]
  )

  const handleOpen = () => {
    updateFilter('')
    apiListNodeOrg.get()
    apiListNodeGroup.get(`${groupID}/group`)
  }
  const handleClose = () => onClose && onClose()

  const handleAdd = async nodeID => {
    await apiListNodeGroup.post({ nodeID: nodeID, groupID: groupID })
    await apiListNodeGroup.get(`${groupID}/group`)
  }

  const handleRemove = async nodeID => {
    await apiListNodeGroup.delete(`${nodeID}/${groupID}`)
    await apiListNodeGroup.get(`${groupID}/group`)
  }

  return (
    <ModalDialog target={target} header="Add Content" fullScreen onOpen={handleOpen} onClose={onClosed}>
      <div className="d-flex flex-column h-100">
        <div>
          <TextFilter value={filter} onChange={updateFilter} />
        </div>
        <div className="flex-fill overflow-auto p-2">
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th style={{ width: 50 }} />
                  <th className="d-none d-md-table-cell">Name</th>
                  <th>Path</th>
                </tr>
              </thead>
              <tbody>
                {filteredItems.map((node, i) =>
                  <Item
                    key={i}
                    node={node}
                    selectedNodeGroups={apiListNodeGroup.items}
                    allowAdd={allowAdd}
                    allowDelete={allowDelete}
                    onAdd={handleAdd}
                    onRemove={handleRemove}
                  />
                )}
              </tbody>
            </table>
          </div>
        </div>
        <div className="pt-1 border-top">
          <ButtonPrimary onClick={handleClose}>close</ButtonPrimary>
        </div>
      </div>
    </ModalDialog>
  )
}

const Item = ({ node, selectedNodeGroups, allowAdd, allowDelete, onAdd, onRemove }) => {
  const isChecked = useMemo(() => selectedNodeGroups.findIndex(selectedNodeGroup => selectedNodeGroup.nodeID === node.id) !== -1, [node, selectedNodeGroups])

  const handleClick = () => {
    if (isChecked) {
      allowDelete && onRemove && onRemove(node.id)
    } else {
      allowAdd && onAdd && onAdd(node.id)
    }
  }

  return (
    <tr style={{ cursor: 'pointer' }} onClick={handleClick}>
      <td>
        <input className="form-check-input" type="checkbox" checked={isChecked} onChange={() => {}} />
      </td>
      <td className="d-none d-md-table-cell">
        {node.name}
      </td>
      <td>
        {node.path}
      </td>
    </tr>
  )
}
